export default {
  demo: false,
  drawer: null,
  startdate: '2018-04-01',
  color: 'red',
  theme: localStorage.getItem('theme') || 'dark',
  shrink: '260',
  image: '' // change if you want a picture but if you are using this internally get rid of the picture links here and in filter.vue
}
